import { render, staticRenderFns } from "./ReviewShortsMedium.vue?vue&type=template&id=43db97c1&scoped=true"
import script from "./ReviewShortsMedium.vue?vue&type=script&lang=js"
export * from "./ReviewShortsMedium.vue?vue&type=script&lang=js"
import style0 from "./ReviewShortsMedium.vue?vue&type=style&index=0&id=43db97c1&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43db97c1",
  null
  
)

export default component.exports